var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6406 15V6.75C20.6406 6.35218 20.4826 5.97064 20.2013 5.68934C19.92 5.40804 19.5384 5.25 19.1406 5.25V5.25C18.7428 5.25 18.3613 5.40804 18.08 5.68934C17.7987 5.97064 17.6406 6.35218 17.6406 6.75V12",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6406 12V3.75C17.6406 3.35218 17.4826 2.97064 17.2013 2.68934C16.92 2.40804 16.5384 2.25 16.1406 2.25C15.7428 2.25 15.3613 2.40804 15.08 2.68934C14.7987 2.97064 14.6406 3.35218 14.6406 3.75V11.25",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6406 11.2969V4.5C11.6406 4.10218 11.4826 3.72064 11.2013 3.43934C10.92 3.15804 10.5384 3 10.1406 3V3C9.7428 3 9.36127 3.15804 9.07997 3.43934C8.79866 3.72064 8.64062 4.10218 8.64062 4.5V15",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6406 11.25V2.25C14.6406 1.85218 14.4826 1.47064 14.2013 1.18934C13.92 0.908035 13.5384 0.75 13.1406 0.75C12.7428 0.75 12.3613 0.908035 12.08 1.18934C11.7987 1.47064 11.6406 1.85218 11.6406 2.25V11.25",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6406 14.9999C20.6406 20.503 17.6406 23.2499 13.5156 23.2499C9.39063 23.2499 7.71672 21.3936 6.76563 19.1249L4.29672 12.3749C3.98453 11.5288 4.1261 10.7441 4.85313 10.3311C5.58063 9.91771 6.53641 10.1305 6.93016 10.8786L8.64063 14.9999",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanCursor);
export default __webpack_public_path__ + "static/media/pan_cursor.c4418074715359d878fb7e8cc4c47ea2.svg";
export { ForwardRef as ReactComponent };